/**
 * Product card
 */
app.productcard = (function() {
    "use strict";
    var moduleName = 'pws',
        isDragging = false,
        enrollAdditional = false,
        alternateModal = false,
        self = {

        init: function() {
            app.main.getTemplate('partial-product-card', {}, true, function() {
                Handlebars.registerPartial('partial-product-card', $('#template-partial-product-card').html());
            });
        },

        /**
         * Enable individual card functions
         */
        enable: function(useModule) {
            if (!app.main.getSettings().product_card_enabled && !app.main.getSettings().unified_shopping_enabled) {
                return;
            }

            // handle additional products carousel in bundle flow
            if (useModule == 'additional') {
                moduleName = 'enroll';
                enrollAdditional = true;

            } else {
                enrollAdditional = false;

                if (useModule === 'enroll') {
                    moduleName = 'enroll';

                } else {
                    moduleName = 'pws';
                }
            }

            $('.card').each(function(index) {
                var $card = $(this),
                    data = self.getCardData($card);

                // add to cart button
                $('.btn-add', $card).off('click').on('click', function(e) {
                    e.preventDefault();
                    self.add($card, false);
                });

                // subscribe button
                $('.btn-subscribe', $card).off('click').on('click', function(e) {
                    e.preventDefault();

                    var subscriptionId = app.skava.hasSubscriptions();

                    if (subscriptionId && useModule === 'pws') {
                        var subData = {
                            "items": [{
                                "quantity": data.qty,
                                "skus": [
                                    {
                                        "skuId": data.item_id.toString() +'_1',
                                        "productId": data.product.product_id.toString(),
                                        "type": 'DEFAULT'
                                    }
                                ],
                                "isSubscription": true,
                                "subscription": {
                                    "frequencyPeriod": "1",
                                    "frequencyType": "MONTHS"
                                },
                                "properties": {}
                            }],
                            "totalCost": app.global.round(data.product.price),
                            "referralId": app.main.getProfile().member_id,
                            "subscriptionId": subscriptionId
                        };

                        app.skava.createSubscription(subData,
                            function(res) {
                                self.updateButton($card, true);
                            },

                            function(err) {
                                var errorMessage = app.main.lang('loyalty_add_failed');

                                if (err.responseText) {
                                    var resText = JSON.parse(err.responseText);
                                    if (resText.message) {
                                        // already subscribed to this item
                                        // errorMessage = resText.message;
                                        errorMessage = app.main.lang('loyalty_already_added');
                                    }

                                    if (resText.responseMessage) {
                                        // user not found
                                        errorMessage = resText.responseMessage;
                                    }
                                }

                                app.message.alert({
                                    type: 'info',
                                    id: 'error-subscriptions',
                                    message: errorMessage
                                });
                            }
                        );                        

                    } else {
                        self.add($card, true, $(this).hasClass('bundle'));
                    }
                });

                // quantity select
                $('.select', $card).off('click').on('click', function(e) {
                    self.openQuantity($card);
                });

                // variant select
                $('.variants-list', $card).on('change', function(e) {
                    var variant_item_id = e.currentTarget.value;
                    self.switchVariant($card, variant_item_id);

                    // refresh data after a variant is selected
                    data = self.getCardData($card);
                });

                // product modal
                $('.product-image, .link-product-name', $card).off('click').on('click', function(e) {
                    e.preventDefault();
                    self.productModal(data);
                });

                // trigger all variants to set views - todo: fix this
                if (data.product && data.product.variants) {
                    if ($card.attr('data-type') !== 'minimal' && $card.attr('data-default')) {
                        self.switchVariant($card, $card.attr('data-default'));
                    }
                }
            });

            $('.learn-more').on('click', function(e) {
                e.preventDefault();
                var product = app[moduleName].getProductByID($(this).attr('data-part-number'), 'part_number');

                app.modal.load('product-modal', {
                    profile: app.main.getProfile(),
                    product: product
                });

                $('#modal a').on('click', app.modal.close);

                app.main.track('CE Products', $(this).data('trackingaction'), $(this).attr('data-part-number'));
            });

            // subscribe modal
            $('.link-subscribe-modal').off('click').on('click', function(e) {
                e.preventDefault();
                self.subscribeModal();
            });

            // close the help popup if carousel is dragged
            $('.carousel').off().on('mousedown touchstart', function(e) {
                app.page.closeTip();
            });

            // unified shopping doesn't use the normal product card, handle variants here
            if (app.main.getSettings().unified_shopping_enabled) {
                $('.pws-item').each(function(index) {
                    var $card = $(this),
                        data = self.getCardData($card);

                    // variant select
                    $('.variants-list', $card).on('change', function(e) {
                        var variant_item_id = e.currentTarget.value;
                        self.switchVariantUnified($card, variant_item_id);

                        // refresh data after a variant is selected
                        data = self.getCardData($card);
                    });

                    // trigger all variants to set views
                    if (data.product && data.product.variants) {
                        var variant_id = $card.attr('data-id');

                        // find first in_stock variant
                        for (var i=0; i<data.product.variants.length; i++) {
                            var variant = data.product.variants[i];
                            if (variant.in_stock) {
                                variant_id = variant.item_id;
                                break;
                            }
                        }

                        self.switchVariantUnified($card, variant_id);
                    }

                });
            }

            // discount helptips
            app.page.initHelpTips();
            self.setAddedItems();
        },

        /**
         * Gather card data attribute values
         */
        getCardData: function($card) {
            var data = {
                item_id: $card.attr('data-id'),
                qty: $card.attr('data-qty')
            };

            var product = app[moduleName].getProductByID(data.item_id, 'item_id');

            if (product) {
                data.product = product;
            }

            return data;
        },

        /**
         * Add single product to cart
         */
        add: function($card, subscribe, bundleLoyalty) {
            if (isDragging) return;

            var data = self.getCardData($card);

            if (enrollAdditional) {
                // hybrid add/subscribe in enrollment flow
                var productType = subscribe ? 'monthly' : 'regular';

                app.enroll.toggleProduct(data.item_id, 'review', false, productType, data.qty);

                // also add it to the current enrollmentPackage
                app.enroll.addAdditionalProduct(data.item_id, data.qty, subscribe);

                var addProduct = [{
                    quantity: data.qty,
                    skus: [
                        {
                            skuId: data.item_id.toString() +'_1',
                            productId: data.product.product_id,
                            type: "DEFAULT"
                        }
                    ],
                    properties: {},
                    isSubscription: subscribe
                }];

                app.skava.sendRequest({
                    url: '/cart/',
                    method: 'POST',
                    data: JSON.stringify(addProduct)
                }, 

                function(data) {
                    var $btn = $('.btn-add', $card);
                    self.cartProductEvent(data);
                    self.updateButton($card, subscribe, $btn.hasClass('added'));

                    // re-render without a full update
                    app.enroll.refreshReview(true);
                },

                function(err) {
                    console.log(err);
                });

            } else if (moduleName === 'enroll') {
                var $btn = $('.btn-add', $card),
                    productType = subscribe ? 'monthly' : 'products';

                if ($card.attr('data-type') === 'bundle') {
                    productType = 'kits';

                    if (subscribe) {
                        // add bundle to loyalty order
                        productType = 'bundle-loyalty';
                    }


                    // toggle between buttons - can't subscribe and add at the same time
                    if (bundleLoyalty === true) {
                        if ($('.btn-add', $card).hasClass('added')) {
                            // remove added bundle
                            app.enroll.resetKits();
                            $('.btn-add', $card).click();
                        }

                    } else {
                        if ($('.btn-subscribe', $card).hasClass('added')) {
                            // remove subscribed bundle
                            app.enroll.resetKits();
                            $('.btn-subscribe', $card).click();
                        }
                    }

                }

                if (subscribe) {
                    $btn = $('.btn-subscribe', $card);
                }

                var added = app.enroll.toggleProduct(data.item_id, productType, false, false, data.qty);

                if (added === true) {
                    self.cartProductEvent(data);

                } else {
                    self.cartProductEvent(data, true);
                }

                self.updateButton($card, subscribe, $btn.hasClass('added'), bundleLoyalty);

            } else {
                var cartItem = {
                    itemId: data.item_id,
                    quantity: parseInt(data.qty, 10),
                    isSubscription: subscribe
                };

                // default to pws
                app.cart.addToCart(cartItem, function() {
                    self.updateButton($card, subscribe);
                    app.cart.displaySingleItemCart();
                    self.cartProductEvent(data);
                });
            }
        },

        /**
         * Google add_to_cart event and remove_from_cart are identical except for type
         */
        cartProductEvent: function(data, remove) {
            if (!data) {
                return;
            }

            var type = 'add_to_cart',
                category = '';

            if (remove === true) {
                type = 'remove_from_cart';
            }

            category = app.skava.getCategoryByID(data.product.categories[0]);
            
            if (category) {
                category = category.name;

            } else {
                // first category available
                category = app.skava.getCategories()[0].name;
            }

            app.ga.event(type, {
                'currency': app.global.currency(false).label,
                'value': app.global.round(data.product.price * data.qty),
                'items': [{
                    'item_id': data.product.sku_id,
                    'item_name': data.product.name,
                    'affiliation': app.main.getProfile().member_id,
                    'coupon': app.skava.getPromoCode(),
                    // currency: app.global.currency(false).label,
                    // discount: data.product.total_discount,
                    // index: 0,
                    'item_brand': data.product.isSubscription ? 'Loyalty Order' : 'Individual Item',
                    'item_category': category,
                    // item_list_id: 'related_products',
                    // item_list_name: 'Related Products',
                    'item_variant': data.product.variant,
                    'price': app.global.round(data.product.price),
                    'quantity': data.qty
                }]
            });
        },

        /**
         * Open the quantity select list
         */
        openQuantity: function($card) {
            if (isDragging) return;

            // init quantity select
            var pos = $('.select', $card).offset(),
                $select = $('#select-list');

            if ($card.hasClass('is-active')) {
                self.closeQuantity();

            } else {
                // self.closeQuantity();
                $card.addClass('is-active');
                $(window).on('resize', self.closeQuantity);

                $select.css({
                    top: Math.round(pos.top) + 39,
                    left: Math.round(pos.left)
                }).show();

                $('li:not(.other)', $select).on('click', function() {
                    self.setQuantity($card, $(this).text());
                    self.closeQuantity();
                });
            }

            $('li.other input', $select)
                .on('keyup blur', function(e) {
                    var num = $(this).val().replace(/\D/g, '');
                    $(this).val(num);

                    switch (e.keyCode) {
                        // enter/return
                        case 13:
                            self.setQuantity($card, num);
                            self.closeQuantity();
                        break;
                        // esc
                        case 27:
                            self.closeQuantity();
                        break;
                    }
                })

                .on('focus', function() {
                   // disable the document mousdown handler so the blur event will take precedence
                   $('body, .carousel').off('mousedown touchstart');
                })

                .on('blur', function() {
                    if ($(this).val()) {
                        self.setQuantity($card, $(this).val());
                        self.closeQuantity();
                    }
                });

            // close the select drop-down when anything else is clicked
            $('body, .carousel').off().on('mousedown touchstart', function(e) {
                // ignore on the select-list element or quantity field inside it (other)
                if (e.target.parentElement.id != 'select-list' && e.target.parentElement.className != 'other') {
                    self.closeQuantity();
                    $('body, .carousel').off('mousedown touchstart');
                }
            });
        },

        /**
         * Close and disable and product quantity select lists
         */
        closeQuantity: function() {
            $(window).off('resize', self.closeQuantity);
            $('.card').removeClass('is-active');
            $('#select-list li').off('click');
            $('#select-list .other input').val('').off('keyup blur');
            $('#select-list').hide();
        },

        /**
         * Sets the quantity value based on selection or 'other' field entry
         */
        setQuantity: function($card, num) {
            num = parseInt(num, 10);

            if (num < 1 || isNaN(num)) {
                return;
            }

            $('.selected', $card).text(num);
            // $('.field-quantity', $card).val(num);
            $card.attr('data-qty', num);
        },

        /**
         * Change card details when switching variants
         */
        switchVariant: function($card, item_id) {
            var product = app[moduleName].getProductByID(item_id, 'item_id');

            if (product) {
                $card.attr('data-id', product.item_id);
                var bgImage = 'url('+ product.image_url +')';

                if (product.image_new) {
                    // add fallback image
                    bgImage = 'url('+ product.image_new +'), url('+ product.image_url +')'
                }

                $('.card-image', $card).css({
                   'background-image': bgImage
                });

                $('.product-image', $card).attr('src', product.image_url);

                // $('.product-image', $card).attr('src', product.image_url);
                $('.link-product-name', $card).text(product.name);
                $('.discount', $card).text(app.global.currency(product.price_after_discount));
                $('.price', $card).text(app.global.currency(product.price));
                $('.pv', $card).text(app.global.round(product.point_value));

                $('.variants-list option[value="'+ item_id +'"]', $card).prop('selected', true);

                if (moduleName === 'pws') {
                    if (product.subscription) {
                        $('.row.subscribe', $card).show();

                    } else {
                        $('.row.subscribe', $card).hide();
                    }
                }

            } else {
                console.log('Variant '+ item_id +' not found');
            }
        },

        /**
         * Unifiwed shopping: Change card details when switching variants
         */
        switchVariantUnified: function($card, item_id) {
            var product = app[moduleName].getProductByID(item_id, 'item_id');

            if (product) {
                $card.attr('data-id', product.item_id);
                $('.cart-add', $card).attr('data-item_id', product.item_id);
                // var bgImage = 'url('+ product.image_url +')';

                // if (product.image_new) {
                //     // add fallback image
                //     bgImage = 'url('+ product.image_new +'), url('+ product.image_url +')'
                // }

                $('.product-image', $card).attr('src', product.image_url);
                $('.product-name', $card).text(product.name + (product.variant ? ' - '+ product.variant : ''));
                $('.part-number', $card).text(product.part_number);
                $('.retail', $card).text(app.global.currency(product.retail_price));
                $('.wholesale', $card).text(app.global.currency(product.wholesale_price));
                $('.pv', $card).text(app.global.round(product.retail_point_value));
                $('.variants-list option[value="'+ item_id +'"]', $card).prop('selected', true);

                // show/hide out of stock message or select checkbox depending on in_stock
                if (product.in_stock) {
                    $('.add-to-cart', $card).show();
                    $('.out-of-stock', $card).hide();

                } else {
                    $('.add-to-cart', $card).hide();
                    $('.out-of-stock', $card).show();
                }

            } else {
                console.log('Variant '+ item_id +' not found');
            }
        },

        /**
         * Mark cards as added if found in cart
         */
        setAddedItems: function() {
            if (moduleName === 'pws') {
                var addedItems = app.cart.getCartItems();

                addedItems.forEach(function(item) {
                    var $card = $('[data-id="'+ item.item_id +'"]');

                    if ($card) {
                        self.updateButton($card, item.isSubscription);
                        $card.attr('data-qty', item.quantity);
                        $('.selected', $card).text(item.quantity);
                    }
                });

            } else {
                var enrollmentSelected = app.enroll.getEnrollmentSelected(),
                    keys = ['kits', 'monthly', 'products'],
                    i;

                for (i=0; i<keys.length; i++) {
                    enrollmentSelected[keys[i]].forEach(function(item) {
                        if (typeof item !== 'object') {
                            item = {
                                item_id: item,
                                quantity: 1
                            };
                        }

                        var $card = $('[data-id="'+ item.item_id +'"]', $('.product-list.'+ keys[i]));

                        if ($card) {
                            if ($card.attr('data-type') === 'subscribe' || item.isSubscription) {
                                item.isSubscription = true;

                            } else {
                                item.isSubscription = false;
                            }

                            self.updateButton($card, item.isSubscription, false, $card.attr('data-type') == 'bundle');
                            $card.attr('data-qty', item.quantity);
                            $('.selected', $card).text(item.quantity);
                            self.switchVariant($card, item.item_id);
                        }
                    });
                }
            }
        },

        /**
         * Set button state after adding an item
         */
        updateButton: function($card, isSubscription, remove, bundleLoyalty) {
            var btn = '.btn-add';
            var text = app.main.lang('add_to_cart_cta');
            var textAdded = app.main.lang('added_to_cart_cta');
            var check = '<span>&check;</span>';

            if (isSubscription === true) {
                btn = '.btn-subscribe';

                text = app.main.lang('btn_loyalty');
                textAdded = app.main.lang('btn_loyalty_added');
            }

            if (moduleName === 'enroll') {
                text = app.main.lang('ce_add');
                textAdded = app.main.lang('ce_added');

                if ($card.attr('data-type') === 'bundle') {
                    if (bundleLoyalty === true) {
                        if (app.skava.hasSubscriptions()) {
                            text = app.main.lang('btn_loyalty');

                        } else {
                            text = app.main.lang('btn_loyalty_new');
                        }

                        if (btn == '.btn-add') {
                            textAdded = app.main.lang('btn_bundle_added');

                        } else {
                            textAdded = app.main.lang('btn_loyalty_added');
                        }

                    } else {
                        text = app.main.lang('btn_bundle_add');
                        textAdded = app.main.lang('btn_bundle_added');
                    }
                }
            }

            if (remove) {
                $(btn, $card).html(text).removeClass('added');

            } else {
                $(btn, $card).html(check + textAdded).addClass('added');
            }
        },

        setAlternateModal: function(bool) {
            alternateModal = bool === true;
        },

        productModal: function(data) {
            if (isDragging) return;

            if (data.product) {
                if (alternateModal) {
                    app.modal.init('#modal2');
                }

                app.modal.load('product-card-modal', {
                    product: data.product

                }, app.modal.init);
            }
        },

        subscribeModal: function() {
            if (isDragging) return;

            if (alternateModal) {
                app.modal.init('#modal2');
            }

            app.modal.load('subscribe-modal', {}, app.modal.init);
        },

        setIsDragging: function(bool) {
            isDragging = bool ? true : false;
        }
    };

    return self;
}());
